const Map = () => {
	return ( 
		<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3379.8325070501664!2d34.78217731453344!3d32.10081218118143!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d4bfaba8c0d59%3A0x79a7b51f089693f9!2sRofe%20ha-Makhtarot%20St%2032%2C%20Tel%20Aviv-Yafo!5e0!3m2!1sen!2sil!4v1612195879661!5m2!1sen!2sil" width="100%" height="450" frameBorder="0" style={{border:"0"}} allowFullScreen="" aria-hidden="false" tabIndex="0"></iframe>
	);
}
 
export default Map;